export class DiseaseForGridModel {
  public diseaseId: number;
  public diseaseName: string;
  public diseaseCode: string;
  public diseaseHistoryCount: number;
  public hasActiveHistory: boolean;
}